import * as types from "./actionTypes";
import * as listApi from "../../api/listApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadFoodsSuccess(foods) {
  return { type: types.LOAD_FOODS_SUCCESS, foods };
}

export function loadFoods() {
  return function (dispatch) {
    dispatch(beginApiCall());
    return listApi
      .getFoods()
      .then(foods => {
        const array = foods.map(food => food.value);
        dispatch(loadFoodsSuccess(array));
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
